// extracted by mini-css-extract-plugin
export default {"detailSection":"DetailSection_detailSection__WfVEA"};